import React from 'react'
import { useDispatch, useSelector } from '../../../../store'
import { PercentageUpDown, TableComponentV2 } from '@labrav/react-components'
import { ButtonsRecords } from '../../../../modules/storefrontMetrics/reducer'

import { Typography } from '@mui/material'
import { useStyles } from './TableViewClicksAndSubmissions.styles'
import {
  getFormattedLabel,
  getPercentageType,
} from '../../FlyOutImpressions/FlyOutImpressions'
import { LoadingTypes, isLoading } from '@labrav/common'

export const TableViewClicksAndSubmissions: React.FC<{
  buttonsData: ButtonsRecords[]
}> = ({ buttonsData }) => {
  const dispatch = useDispatch()
  const loading = useSelector<boolean>(state =>
    isLoading(state.loading)(LoadingTypes.GENERAL)
  )
  const { classes } = useStyles()

  const buttonsRecordsMapping = {
    Buttons: 'keywordName',
    Clicks: 'clicks',
    'Form submissions': 'formSubmissionPercentage',
  }
  const buttonsRecordObject =
    (buttonsData || []).length > 0
      ? buttonsData.map(buttonData => {
          const button = { ...buttonData } as ButtonsRecords
          return {
            keywordName: getFormattedLabel(button.key),
            clicks: button.clicks ? (
              <div className={classes.tableContentWrapper}>
                <Typography>{button.clicks} </Typography>
                <PercentageUpDown
                  percentage={parseFloat(
                    button?.clickPercentage?.toFixed(2) as string
                  )}
                  isPercentage={true}
                  type={getPercentageType(button.clickPercentage as number)}
                />
              </div>
            ) : (
              '-'
            ),
            formSubmissionPercentage: button.formSubmissionPercentage ? (
              <div className={classes.tableContentWrapper}>
                <Typography>{button.formSubmission}</Typography>
                <PercentageUpDown
                  percentage={parseFloat(
                    button.formSubmissionPercentage?.toFixed(2) as string
                  )}
                  isPercentage={true}
                  type={getPercentageType(
                    button.formSubmissionPercentage as number
                  )}
                />
              </div>
            ) : (
              '-'
            ),
          }
        })
      : []

  return (
    <>
      <div data-testid="buttons-tableV2" style={{ width: '100%' }}>
        <TableComponentV2
          keyName={'clicksAndSubmissons'}
          objects={buttonsRecordObject}
          mapping={buttonsRecordsMapping}
          fetchMoreData={() => void 0}
          selectedItem={[]}
          onChangeCheckbox={() => void 0}
          showCheckbox={false}
          isLoading={false}
          breakWorkHeader={false}
          tableHeight={'fit-content'}
          hasMoreData={false}
        />
      </div>
    </>
  )
}
